import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../helpers/hooks";
import { useNavigate } from "react-router-dom";
import { Carousel } from "antd";
import CustomRightArrow from "../ContentWizard/CustomRightArrow";
import CustomLeftArrow from "../ContentWizard/CustomLeftArrow";
import PreviousDesignsGridCard from "../ContentWizard/PreviousDesignsGridCards";
import { useWindowSize } from "@uidotdev/usehooks";
import { LoopsResponse, useLazyLoopsQuery } from "../../services/ContentApi";
import { toggleLoading } from "../../store/appSlice";
import { t } from "i18next";
import { Project, useListProjectsMutation } from "../../services/ProjectApi";


const ContinueYouLeft = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const size = useWindowSize();
    const [items, setItems] = useState<Project[]>([]);
    const collapsedModeEnabled = useAppSelector(
        (state) => state.app.collapsedModeEnabled
    );

    const [
        getProjects,
        {
            isLoading: projectListLoading,
            isSuccess: projectListSuccess,
            error: projectListError,
            data: projectList,
        },
    ] = useListProjectsMutation();


    useEffect(() => {
        dispatch(
            toggleLoading(
                projectListLoading
            )
        );
    }, [
        projectListLoading
    ]);

    useEffect(() => {
        setItems([]);
        getLoopList(0);
        return () => {
            setItems([]);
        };
    }, []);


    useEffect(() => {
        if (projectList && projectList.length > 0) {
            setItems(projectList);
        }
    }, [projectList]);

    const getLoopList = (page) => {
        var payload = {
            page: page,
            size: 20,
        };

        getProjects({ listProjectRequest: payload });
    };

    const isMobile = () => {
        return size.width && size.width <= 500;
    };

    return (
        <> {
            items?.length &&
            <div className="w-full flex flex-col gap-5">
                <div className="mt-[50px] mb-[20px]">
                    <div className="flex justify-between items-center w-full">
                        <span className="text-H4 font-medium text-black   truncate text-ellipsis overflow-hidden">
                            Continue Where You Left Off
                        </span>
                        <button
                            className="text-red text-BodyMedium underline font-inter-tight"
                            onClick={() => {
                                navigate("/app/loops")
                            }}
                        >
                            {t("see-all")}
                        </button>
                    </div>

                    <hr className="bg-border mt-1 " />
                </div>
                <div className={`flex-col ${collapsedModeEnabled ? 'max-w-[1180px]' : 'max-w-[1050px]'} `}>
                    <Carousel
                        slidesToShow={isMobile() ? 1 : (collapsedModeEnabled ? 6 : 5)}
                        nextArrow={<CustomRightArrow />}
                        prevArrow={<CustomLeftArrow />}
                        dots={false}
                        arrows={items?.length > 5}
                        adaptiveHeight={true}
                    >
                        {items.map((k, index) => (
                            <PreviousDesignsGridCard
                                key={index}
                                project={k}
                                updateLoops={() => { }}
                                onSelect={(project_id) => {
                                    navigate(`/editor?project_id=` + project_id);
                                }}
                            />
                        ))}
                    </Carousel>
                </div>
            </div>
        }
        </>

    );
};

export default ContinueYouLeft;
